import { ShapeCircle } from "@/shapeStorage/shapes/basic/circle";

export class ShapeStartEvent extends ShapeCircle {}
